import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Checkbox, Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';

import Modal from 'components/shared/modal/content';
import PopupHeader from 'components/pages/popupHeader';
import Info from 'components/pages/info.js';
import Txt from 'components/inputs/textInput.js';
import SearchSelectUsers from 'components/inputs/searchSelectUsers';
import { showHideWaitingAreaAddUsersModal } from 'actions/modal.js';
import { clearSearchUserForm } from 'actions/user.js';

import {
  selectRoleAddUsersForm,
  unSelectRoleAddUsersForm,
  updateMessageAddUsersForm,
  addUsersToWaitingArea,
  clearAddUsersForm,
} from 'actions/waitingArea';

export default function WaitingAreaAddUsersModal(props) {
  const dispatch = useDispatch();
  const [isAddingUsers, setIsAddingUsers] = useState(false);
  const selectedUsers = useSelector((state) => state.usersReducer.searchSelectUsersForm.selectedUsers);
  const addUsersForm = useSelector((state) => state.waitingAreaReducer.addUsersForm);
  const messageData = useSelector((state) => state.globalMessageReducer.messageData);

  const onSaveButtonClick = (e) => {
    // exit now if event type is not a click (https://jira.attendanywhere.com/browse/VCM-5061)
    // if (!e.isTrusted) return;

    // exit now if form is invalid
    if (selectedUsers.length === 0 || addUsersForm.selectedRoles.length === 0 || isAddingUsers) return;

    const requestModel = {
      userInvites: selectedUsers.filter((user) => !user.isEmailOnlyUser).map((user) => user.id),
      emailInvites: selectedUsers.filter((user) => user.isEmailOnlyUser).map((user) => user.email),
      roles: addUsersForm.selectedRoles,
      invitationMessage: addUsersForm.message,
    };

    setIsAddingUsers(true);
    let cb = (res) => {
      setIsAddingUsers(false);
      if (res) {
        // log the response
        console.log('User registration urls: ' + res.toString());
      }
    };

    dispatch(addUsersToWaitingArea(props.waitingArea, requestModel, cb));
  };

  const onCancelButtonClick = (event) => {
    if (!window.$(event.target).hasClass('disable')) {
      dispatch(showHideWaitingAreaAddUsersModal(false));
      dispatch(clearSearchUserForm());
      dispatch(clearAddUsersForm());
    }
  };

  const onInviteMessageChange = (value) => {
    dispatch(updateMessageAddUsersForm(value));
  };

  const onRoleNameCheckboxChange = (isChecked, roleId) => {
    isChecked ? dispatch(selectRoleAddUsersForm(roleId)) : dispatch(unSelectRoleAddUsersForm(roleId));
  };

  let title = APP.LANGUAGE.WaitingAreaAddUsersModal.Title;
  let subtitle = `${props.waitingArea.name} (${props.waitingArea.organisationAbbreviatedName})`;

  // Right panel
  let buttonClasses = 'ui labeled icon button left-text color-white max-width  mrlnull mrbnull';

  let cancelButtonClasses = buttonClasses + ' color-bad-things color-bad-things-hover mrtm';
  let addUserButtonClasses = buttonClasses + ' color-button color-button-hover';
  let cancelButtonIconClasses = 'remove icon';
  // disable Add button of form state not valid
  if (
    selectedUsers.length === 0 ||
    addUsersForm.selectedRoles.length === 0 ||
    (messageData && messageData.text.toString().indexOf(APP.LANGUAGE.ServerErrors.InvalidEmailGeneralError) > -1)
  )
    addUserButtonClasses += ' disable';

  // show loading indicator
  if (isAddingUsers) {
    addUserButtonClasses += ' loading';
    cancelButtonClasses += ' disable';
    cancelButtonIconClasses += ' disable';
  }

  let rightPanel = (
    <div>
      <div className="ui actions mrtxxs mrbl max-width">
        <button
          tabIndex="4"
          type="button"
          onClick={(e) => {
            onSaveButtonClick(e);
          }}
          className={addUserButtonClasses}
        >
          {APP.LANGUAGE.Save}
          <i className="checkmark icon" />
        </button>
        <button
          tabIndex="5"
          type="button"
          onClick={(e) => {
            onCancelButtonClick(e);
          }}
          className={cancelButtonClasses}
        >
          <i
            className={cancelButtonIconClasses}
            onClick={(e) => {
              onCancelButtonClick(e);
            }}
          />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
      <Info
        paragraphs={[
          APP.LANGUAGE.WaitingAreaAddUsersModal.InfoPartOne,
          APP.LANGUAGE.WaitingAreaAddUsersModal.InfoPartTwo,
        ]}
      />
    </div>
  );

  const availableRolesMarkUp = (isOnDesktop) => {
    return props.availableRoles.map((role, index) => {
      return (
        <Checkbox
          name={role.name}
          key={role.id}
          checked={!!addUsersForm.selectedRoles.find((id) => id === role.id)}
          tabIndex={index}
          className={'div-like ' + (isOnDesktop ? 'mrbs' : 'mrbm')}
          onClick={(e, data) => {
            onRoleNameCheckboxChange(data.checked, role.id);
          }}
          label={role.name}
        />
      );
    });
  };

  return (
    <Modal show={true} hideWhenClickAway={false}>
      <PopupHeader helpLink={APP.EXTERNAL_LINKS.ManageUsers.HelpAddUsers} title={title} subtitle={subtitle} />
      <div className="content">
        <div className="main-ui-container manage-roles-for-users-modal">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
            </div>
            <div>
              <div className="ui form grid">
                <div className="sixteen wide column">
                  <SearchSelectUsers
                    allowNewInvite={true}
                    allowMultipleUserSelection={true}
                    dispatch={dispatch}
                    entityType={'Waiting Area'}
                  />
                </div>
                <div className="sixteen wide column pdtnull pdbxxs">
                  <div className="placeholder-label color-placeholder div-like mrbs">
                    {APP.LANGUAGE.WaitingAreaAddUsersModal.SelectRolesFieldLabel}
                  </div>
                </div>
                <div className="sixteen wide column pdtnull pdbnull">
                  <Container fluid as={Media} lessThan="computer">
                    {availableRolesMarkUp(false)}
                  </Container>
                  <Container fluid as={Media} greaterThanOrEqual="computer">
                    {availableRolesMarkUp(true)}
                  </Container>
                </div>
                <div className="sixteen wide column mrtl mrbm">
                  <Txt
                    textArea
                    tabIndex="2"
                    placeholder={APP.LANGUAGE.WaitingAreaAddUsersModal.InvitationMessageFieldLabel}
                    notRenderPlaceholderAsTitle={true}
                    value={addUsersForm.message}
                    onChange={(value) => {
                      onInviteMessageChange(value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="bottom-rail-with-left-and-right-content mrtl">{rightPanel}</div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

WaitingAreaAddUsersModal.propTypes = {
  waitingArea: PropTypes.object.isRequired,
  availableRoles: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
};
